import { KW } from './theme'

/** Three blinking dots — the assistant is thinking / a tool is running. */
const TypingDots = () => (
  <div className="flex gap-[5px] px-[2px] py-[7px]">
    {[0, 1, 2].map(i => (
      <span
        key={i}
        className="inline-block h-[7px] w-[7px] rounded-full"
        style={{
          background: KW.muted,
          animation: `kw-blink 1s ${i * 0.18}s infinite`,
        }}
      />
    ))}
  </div>
)

export default TypingDots
